import {
  CHECK_IN_USER,
  CHECK_IN_USER_FAILED,
  GET_CURRENT_ACTIVITY,
  GET_USER_CHECKIN,
  GET_USER_CHECKIN_FAILED,
  LOAD_ALL_ACTIVITIES,
  LOAD_ALL_ACTIVITIES_FAILED,
  LOAD_CUSTOMERS,
  LOAD_CUSTOMERS_FAILED,
  LOAD_WORK_ORDERS,
  LOAD_WORK_ORDERS_FAILED,
  LOAD_WORK_ORDERS_SUCCESS,
  UPDATE_ACTIVITY,
  DELETE_ACTIVITY, UPDATE_ACTIVITY_DURATION, UPDATE_CHECKIN_WORKDAY, DELETE_CHECKIN, GO_TO_TIMESHEET,
} from '../../actions/checkIn';

export const ACTIVITY_STATUS = {
    'PAUSE': 'PAUSE',
    'RESUME': 'RESUME',
    'STOP': 'STOP'
}

export default function checkIn(state = {}, action) {
    switch (action.type) {
        case LOAD_ALL_ACTIVITIES:
            return Object.assign({}, state, action.payload);
        case LOAD_ALL_ACTIVITIES_FAILED:
            return Object.assign({}, state, action.payload);
        case LOAD_CUSTOMERS:
            return Object.assign({}, state, action.payload);
        case LOAD_CUSTOMERS_FAILED:
            return Object.assign({}, state, action.payload);
        case LOAD_WORK_ORDERS:
            return Object.assign({}, state, action.payload);
        case LOAD_WORK_ORDERS_SUCCESS:
            return Object.assign({}, state, action.payload);
        case LOAD_WORK_ORDERS_FAILED:
            return Object.assign({}, state, action.payload);
        case CHECK_IN_USER:
            return Object.assign({}, state, action.payload);
        case CHECK_IN_USER_FAILED:
            return Object.assign({}, state, action.payload);
        case GET_USER_CHECKIN:
            // console.log('GET_USER_CHECK IN CALLED', action.payload);
            return Object.assign({}, state, action.payload);
        case GET_USER_CHECKIN_FAILED:
            return Object.assign({}, state, action.payload);
        case GET_CURRENT_ACTIVITY:
            return Object.assign({}, state, action.payload);
        case UPDATE_ACTIVITY:
            const updatedState = { ...state };
            if (updatedState.currentActivity.id === action.payload.activityId) {
                switch (action.payload.status) {
                    case ACTIVITY_STATUS.RESUME:
                        updatedState.currentActivity.status = 'active';
                        break;
                    case ACTIVITY_STATUS.PAUSE:
                        updatedState.currentActivity.status = 'paused';
                        break;
                    case ACTIVITY_STATUS.STOP:
                        updatedState.currentActivity.status = 'stopped';
                        break;
                }            }
            return Object.assign({}, state, updatedState);
        case DELETE_ACTIVITY:
          return Object.assign({}, state, action.payload);
        case UPDATE_ACTIVITY_DURATION:
          return Object.assign({}, state, action.payload);
        case UPDATE_CHECKIN_WORKDAY:
          return Object.assign({}, state, action.payload);
        case DELETE_CHECKIN:
          return Object.assign({}, state, action.payload);
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/checkIn/index.js